<template>
  <v-menu
    close-on-click
    offset-y
  >
    <template #activator="{ on, attrs }">
      <slot name="activator" :attrs="attrs" :on="on" :loading="isLoadingAsyncData">
        <v-btn
          v-bind="attrs"
          :loading="isLoadingAsyncData"
          :disabled="isLoadingAsyncData"
          depressed
          class="pa-1"
          style="min-width: 0;"
          v-on="on"
        >
          <span v-text="label" />
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </slot>
    </template>

    <v-list dense>
      <template v-for="report in list">
        <v-list-item :key="report.value" link @click="onClick(report)">
          <v-list-item-content>
            <v-list-item-title>
              {{ report.text }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="report.tooltip">
              {{ report.tooltip }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'BTableButtonList',
  props: {
    label: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    isLoadingAsyncData: false,
  }),
  methods: {
    toggleLoading() {
      this.isLoadingAsyncData = !this.isLoadingAsyncData
      return this.toggleLoading
    },
    onClick(v) {
      this.$emit('action:click', v, this.toggleLoading)
    },
  },
}
</script>
